import { render, staticRenderFns } from "./SectionBlockPanel.vue?vue&type=template&id=35566cac&"
import script from "./SectionBlockPanel.vue?vue&type=script&lang=js&"
export * from "./SectionBlockPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports